<div class="container-fluid mt-3 px-4" style="font-size: 0.88rem;">
  <form [formGroup]="cotizacionForm" (ngSubmit)="guardarPresupuesto()">
    
    <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
      <div>
        <h2 class="h5 m-0 fw-bold text-dark">Rampa de Presupuestos - Nueva Cotización</h2>
        <span class="small text-muted font-monospace">JDE Commercial Matrix / Recepcion ID: #{{ idRecepcion }}</span>
      </div>
    </div>

    <div class="card border-0 bg-transparent">
      <div class="card-body p-0">
        
        <!-- Fila de Parámetros Comerciales -->
        <div class="row g-3 mb-4">
          <div class="col-md-3">
            <label class="form-label font-monospace fw-bold text-secondary">VIGENCIA (DÍAS)</label>
            <input type="number" class="form-control form-control-sm shadow-sm text-uppercase" formControlName="vigenciaDias"
                   [ngClass]="{'is-invalid': (cotizacionForm.get('vigenciaDias')?.touched || intentarGuardar) && cotizacionForm.get('vigenciaDias')?.invalid}">
          </div>
          <div class="col-md-5">
            <label class="form-label font-monospace fw-bold text-secondary">NOTAS INTERNAS / COMENTARIOS CLIENTE</label>
            <input type="text" class="form-control form-control-sm shadow-sm text-uppercase" formControlName="comentariosCliente" placeholder="Ej: RUIDO REPORTADO EN AMORTIGUADOR DELANTERO...">
          </div>
          <div class="col-md-4 d-flex align-items-end justify-content-md-end">
            <div class="form-check form-switch p-2 bg-white rounded shadow-sm border border-secondary-subtle">
              <input class="form-check-input ms-0 me-2" type="checkbox" id="ivaSwitch" [(ngModel)]="ivaIncluido" [ngModelOptions]="{standalone: true}" (change)="conmutarIvaSwitch()">
              <label class="form-check-label fw-bold text-dark small" for="ivaSwitch"> 💰 Precios con IVA Incluido (16%)</label>
            </div>
          </div>
        </div>

		<!-- 🚀 INYECCIÓN ACORDADA: CROQUIS VEHICULAR INTERACTIVO (MODALIDAD A) -->
        <div class="card shadow-sm border-secondary-subtle mb-4">
          <div class="card-header bg-dark text-white font-monospace fw-bold border-bottom">
            🚗 CROQUIS DE DAÑOS DE LA CARROCERÍA (MODALIDAD A)
          </div>
          <div class="card-body bg-white d-flex flex-column align-items-center py-4">
            <p class="text-muted small mb-3">
              💡 Seleccione un pin de daño sobre la silueta para transformarlo automáticamente en una partida presupuestal detallada.
            </p>
            
            <!-- Contenedor físico calibrado con tu clase original de Recepciones -->
            <div class="croquis-canvas-container">
              
              <!-- Silueta dinámica homologada a tamaño real de 650px sin acartonamiento -->
              <img [src]="currentVehicleSvg" 
                   alt="Silueta Dinámica del Vehículo" 
                   class="croquis-vehicle-img">
              
              <!-- Pines reactivos mapeando snake_case y camelCase con tus clases de color -->
              <div *ngFor="let pin of datosCarroceriaPatio" 
                   class="croquis-pin"
                   [style.left.%]="pin.x_percentage || pin.xPercentage"
                   [style.top.%]="pin.y_percentage || pin.yPercentage"
                   [ngClass]="{
                     'rayon': (pin.tipo_dano || pin.tipoDano) === 'RAYON',
                     'golpe': (pin.tipo_dano || pin.tipoDano) === 'GOLPE',
                     'rotura': (pin.tipo_dano || pin.tipoDano) === 'ROTURA',
                     'oxido': (pin.tipo_dano || pin.tipoDano) === 'OXIDO',
                     'picadura': (pin.tipo_dano || pin.tipoDano) === 'PICADURA'
                   }"
                   [title]="(pin.tipo_dano || pin.tipoDano) + ': ' + pin.descripcion"
                   (click)="vincularPinACotizacion(pin)">
              </div>
              
            </div>
          </div>
        </div>

        <!-- PARTIDAS DEL PRESUPUESTO -->
        <!-- 🚀 ALERTA DE REJILLA VACÍA: Torna el borde rojo si se intenta guardar sin partidas -->
        <div class="card shadow-sm mb-4" [ngClass]="intentarGuardar && lineas.length === 0 ? 'border-danger' : 'border-secondary-subtle'">
          <div class="card-header bg-light text-dark border-bottom d-flex justify-content-between align-items-center py-2.5">
            <span class="fw-bold font-monospace" [ngClass]="intentarGuardar && lineas.length === 0 ? 'text-danger' : 'text-secondary'">📋 PARTIDAS DEL PRESUPUESTO</span>
            <div>
              <button type="button" class="btn btn-sm btn-outline-success me-2 fw-bold shadow-sm" (click)="agregarLinea('Refaccion')">➕ Refacción</button>
              <button type="button" class="btn btn-sm btn-outline-info text-dark me-2 fw-bold shadow-sm" (click)="agregarLinea('Mano de Obra')">➕ Mano de Obra</button>
              <button type="button" class="btn btn-sm btn-outline-warning text-dark fw-bold shadow-sm" (click)="agregarLinea('Servicio Externo')">➕ Ext. Especializado</button>
            </div>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-striped table-hover align-middle mb-0">
                <thead class="table-light text-center font-monospace small">
                  <tr>
                    <th style="width: 15%">Tipo</th>
                    <th style="width: 35%">Descripción Concepto</th>
                    <th style="width: 10%">Cant.</th>
                    <th style="width: 15%">P. Unitario</th>
                    <th style="width: 10%">Desc ($)</th>
                    <th style="width: 10%">Subtotal</th>
                    <th style="width: 5%">Acción</th>
                  </tr>
                </thead>
                <tbody formArrayName="lineas">
                  <tr *ngFor="let control of lineas.controls; let i = index" [formGroupName]="i">
					          <td>
                      <!-- 🎨 SOLUCIÓN: ngStyle fuerza los colores exactos de Costo Fijo independientemente del CSS externo -->
                      <span class="badge w-100 py-2 ms-0 border text-center" 
                            [ngStyle]="{
                              'background-color': control.get('tipoItem')?.value === 'Mano de Obra' ? '#e7f1ff' : (control.get('tipoItem')?.value === 'Refaccion' ? '#198754' : '#ffc107'),
                              'color': control.get('tipoItem')?.value === 'Mano de Obra' ? '#0a58ca' : (control.get('tipoItem')?.value === 'Refaccion' ? '#ffffff' : '#664d03'),
                              'border-color': control.get('tipoItem')?.value === 'Mano de Obra' ? '#0d6efd' : 'transparent'
                            }"
                            style="font-size: 0.78rem; font-weight: bold; display: block; border-radius: 4px;">
                        {{ control.get('tipoItem')?.value | uppercase }}
                      </span>
                    </td>
                    <td>
                      <input type="text" class="form-control form-control-sm text-uppercase" formControlName="descripcion" placeholder="EJ: AMORTIGUADORES DELANTEROS..."
                             [ngClass]="{'is-invalid': (control.get('descripcion')?.touched || intentarGuardar) && control.get('descripcion')?.invalid}">
                    </td>
                    <td>
                      <input type="number" class="form-control form-control-sm text-center font-monospace no-spinners" 
                        formControlName="cantidad" (wheel)="$event.preventDefault()"
                        [ngClass]="{'is-invalid': (control.get('cantidad')?.touched || intentarGuardar) && control.get('cantidad')?.invalid}">
                    </td>
                    <td>
                      <div class="input-group input-group-sm">
                        <span class="input-group-text font-monospace">$</span>
                        <input type="number" class="form-control text-end font-monospace no-spinners" 
                          formControlName="precioUnitario" (wheel)="$event.preventDefault()"
                          [ngClass]="{'is-invalid': (control.get('precioUnitario')?.touched || intentarGuardar) && control.get('precioUnitario')?.invalid}">
                      </div>
                    </td>
                    <td>
                      <input type="number" class="form-control form-control-sm text-end font-monospace no-spinners" 
                        formControlName="descuento" (wheel)="$event.preventDefault()">
                    </td>
                    <td class="text-end fw-bold px-3 font-monospace">
                      {{ control.get('subtotalLinea')?.value | currency:'MXN' }}
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-sm btn-outline-danger border-0" (click)="removerLinea(i)">🗑️</button>
                    </td>
                  </tr>
                  <tr *ngIf="lineas.length === 0">
                    <td colspan="7" class="text-center text-danger py-4 font-monospace fw-bold bg-danger-subtle">
                      ⚠️ ALERTA: EL PRESUPUESTO DEBE CONTENER AL MENOS UN RENGLÓN OPERATIVO PARA PODER SER PROCESADO.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Cierre Financiero -->
        <div class="row justify-content-end bg-white p-3 rounded shadow-sm mx-0 border mb-4">
          <div class="col-md-4 font-monospace">
            <div class="d-flex justify-content-between py-2 border-bottom">
              <span class="text-muted fw-bold">SUBTOTAL NETO:</span>
              <span class="fw-bold text-dark">{{ cotizacionForm.get('subtotal')?.value | currency:'MXN' }}</span>
            </div>
            <div class="d-flex justify-content-between py-2 border-bottom">
              <span class="text-muted fw-bold">IVA TRASLADADO (16%):</span>
              <span class="fw-bold text-dark">{{ cotizacionForm.get('iva')?.value | currency:'MXN' }}</span>
            </div>
            <div class="d-flex justify-content-between py-2 pt-3 fs-5">
              <span class="text-primary fw-bold">TOTAL EXPEDIENTE:</span>
              <span class="text-primary fw-bold">{{ cotizacionForm.get('total')?.value | currency:'MXN' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer bg-light d-flex justify-content-end py-3 border-top px-0">
        <button type="button" class="btn btn-sm btn-outline-secondary px-4 me-3" (click)="alCancelar()" style="border-radius: 6px;">Cancelar</button>
        <button type="submit" class="btn btn-sm btn-primary px-5 fw-bold shadow-sm" style="border-radius: 6px;">
          💾 Guardar y Enviar Presupuesto
        </button>
      </div>
    </div>
  </form>
</div>

<!-- 🌟 CONTENEDOR FLOTANTE DE TOASTS -->
<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080; margin-top: 50px;">
  <div *ngFor="let toast of toastService.toasts" 
       class="toast show shadow border-0 mb-2" 
       [ngClass]="'bg-' + toast.type + '-subtle text-dark'"
       role="alert" aria-live="assertive" aria-atomic="true">
    <div class="toast-header border-0 bg-transparent text-dark d-flex justify-content-between align-items-center">
      <strong class="me-auto d-flex align-items-center gap-2">
        <span>{{ toast.type === 'danger' ? '⚠️' : '✅' }}</span>
        {{ toast.title }}
      </strong>
      <button type="button" class="btn-close" (click)="toastService.remove(toast)"></button>
    </div>
    <div class="toast-body pt-0" style="font-size: 0.85rem;">
      {{ toast.text }}
    </div>
  </div>
</div>
